import { getTheme, Icon, Separator, Stack, Text } from 'office-ui-fabric-react';
import React, { Component } from 'react';

export class EUISeparator extends Component {

    static defaultProps = {
        text: undefined,
        iconName: undefined,
    };

    _theme = getTheme();

    render = () => {

        const { iconName, text } = this.props;
        const themePrimary = this._theme.palette.themePrimary;

        let children = [];
        if (!!iconName) children.push(<Icon key="icon" iconName={iconName} styles={{ root: { color: themePrimary } }} />);
        if (!!text) children.push(<Text key="text" styles={{ root: { color: themePrimary } }}>{text}</Text>);
        if (children.length > 1) children = <Stack horizontal verticalAlign="center" gap={3}>{children}</Stack>;

        return <Separator alignContent="start" styles={{ root: { selectors: { "::before": { background: themePrimary } } }, content: { paddingLeft: 0 } }}>{children}</Separator>;

    };
}